import _sodium from 'libsodium-wrappers';

import localStorageAccess from './localStorageAccess';
import transformer from './transformer';

let sodium: typeof _sodium;
type EncryptionParams = { key: Uint8Array; salt: Uint8Array };

const initSodium = async () => {
  await _sodium.ready;
  sodium = _sodium;
};

const initKeys = async (password: string, currentSalt?: Uint8Array): Promise<EncryptionParams> => {
  await initSodium();
  const { key, salt } = kdf(password, currentSalt);

  const passwordKey = key.slice(0, key.length / 2);
  const encryptionKey = key.slice(key.length / 2, key.length);

  localStorageAccess.setEncryptionKey(transformer.fromUint8ArrayToBase64(encryptionKey));

  return {
    key: passwordKey,
    salt,
  };
};

const kdf = (password: string, currentSalt?: Uint8Array): EncryptionParams => {
  const salt = currentSalt != null ? currentSalt : sodium.randombytes_buf(sodium.crypto_pwhash_SALTBYTES, 'uint8array');
  const key = sodium.crypto_pwhash(
    sodium.crypto_box_SEEDBYTES * 2,
    password,
    salt,
    sodium.crypto_pwhash_OPSLIMIT_INTERACTIVE,
    sodium.crypto_pwhash_MEMLIMIT_INTERACTIVE,
    sodium.crypto_pwhash_ALG_DEFAULT,
    'uint8array'
  );
  return { salt, key };
};

// call init sodium
// encryptionKey übergeben
const encrypt = async (message: string): Promise<Uint8Array> => {
  await initSodium();
  const encryptionKeyAsBase64 = localStorageAccess.getEncryptionKey();

  if (encryptionKeyAsBase64 == null) {
    throw Error('No Encryptin Key');
  }
  const encryptionKey = transformer.fromBase64ToUint8Array(encryptionKeyAsBase64);

  const nonce = sodium.randombytes_buf(sodium.crypto_secretbox_NONCEBYTES);
  const cyphertext = sodium.crypto_aead_xchacha20poly1305_ietf_encrypt(message, null, null, nonce, encryptionKey);

  const payload = new Uint8Array(nonce.length + cyphertext.length);
  payload.set(nonce);
  payload.set(cyphertext, nonce.length);
  return payload;
};

// call init sodium
// encryptionKey übergeben
const decrypt = async (payload: Uint8Array): Promise<string> => {
  await initSodium();
  const encryptionKeyAsBase64 = localStorageAccess.getEncryptionKey();

  if (encryptionKeyAsBase64 == null) {
    throw Error('No Encryptin Key');
  }
  const encryptionKey = transformer.fromBase64ToUint8Array(encryptionKeyAsBase64);
  const nonce = payload.slice(0, sodium.crypto_secretbox_NONCEBYTES);
  const cyphertext = payload.slice(sodium.crypto_secretbox_NONCEBYTES, payload.length);
  return sodium.crypto_aead_xchacha20poly1305_ietf_decrypt(null, cyphertext, null, nonce, encryptionKey, 'text');
};

const encryption = {
  initKeys,
  encrypt,
  decrypt,
};

export default encryption;
